import type { OrgFunctionKind } from '@bliks-io/contracts';

/**
 * The OrgFunction catalog is presented as two kind-fixed pages — „Funktionen"
 * (kind=role) and „Teams" (kind=team) — over the single unified collection
 * (ADR 0004). Every link to a catalog or detail page must pick the route from
 * the row's `kind`; these helpers are the single mapping.
 */

export function orgFunctionCatalogRoute(kind: OrgFunctionKind) {
  return kind === 'team'
    ? ('/$slug/organization/teams' as const)
    : ('/$slug/organization/functions' as const);
}

export function orgFunctionDetailRoute(kind: OrgFunctionKind) {
  return kind === 'team'
    ? ('/$slug/organization/teams/$orgFunctionId' as const)
    : ('/$slug/organization/functions/$orgFunctionId' as const);
}

/**
 * i18n block of the kind's catalog/dialog copy (`organization.teams.*` /
 * `organization.functions.*`) — owned here so the kind→presentation decision
 * isn't re-derived per page.
 */
export function orgFunctionCopyPrefix(kind: OrgFunctionKind) {
  return kind === 'team' ? ('organization.teams' as const) : ('organization.functions' as const);
}
